module.exports = __webpack_public_path__ + "assets/img/9a6c-bd.svg";